import { Storage } from 'aws-amplify';
import * as actionTypes from '../actionTypes/userInfo';
import * as organizationActionType from '../actionTypes/organization';
import userInfoController from '../../../utility/userInfoController';
import Logger from '../../../utility/services/Logger';
import { profileImageExists } from '../../../components/userProfilePage/profileImageQueries';
import getBlobURL from '../../../utility/action-images/getBlob/getBlobURL';
import getImageURLType from '../../../utility/action-images/getBlob/getImageURLType';
import initialTutorialState from '../../constants/initialTutorialState';
import { getUniversityPlan } from '../../../components/userProfilePage/shared/universityAuth';
import getRegionPayment from '../../../utility/getRegionPayment';

const clearUserInfo = async (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_USER_INFO,
    payload: {
      userName: null,
      isFirstSignIn: false,
      isFirstSubscription: false,
      wiseKoin: 0,
      usedCoupon: null,
      referredUser: null,
      isEmailVerified: null,
      organisation: null,
      researchGroup: null,
      researchInterests: [],
      profileImageBlobURL: null,
      totalEarned: 0,
    },
  });
};

const getProfileImageBlobURL = async () => {
  try {
    const key = await profileImageExists();
    const url = key ? await Storage.get(key, { level: 'private' }) : null;
    if (url) {
      const type = getImageURLType(url);
      const blobURL = await getBlobURL(url, type);
      return blobURL;
    }
    return null;
  } catch (err) {
    Logger.LogError(err);
    return null;
  }
};

const updateProfileImageBlobURL =
  (...params) =>
  (dispatch) => {
    const [newProfileImageBlobURL] = params;
    const actionData = {
      type: actionTypes.UPDATE_PROFILE_IMAGE_BLOBURL,
      payload: {
        profileImageBlobURL: newProfileImageBlobURL,
      },
    };
    dispatch(actionData);
  };

export default {
  getUserInfo:
    (...params) =>
    async (dispatch) => {
      const [userId, token] = [...params];
      try {
        const region = await getRegionPayment({ appType: 'CRA' });
        const data = await userInfoController.getUserInfoById(
          userId,
          token,
          region,
        );
        // There is some issue in getProfileImageBlobURL
        const profileImageBlobURL = await getProfileImageBlobURL();
        if (data) {
          // check domain
          let universityDetails = null;
          const provider = localStorage.getItem('sp');
          let signinMethod = localStorage.getItem('sign-in-method');
          let isUniversityEmail = false;
          let domain = '';
          let universitySignIn = false;
          if (signinMethod && signinMethod !== 'local') {
            const { data: userstatus } =
              await userInfoController.checkNonSSOUser(
                {
                  code: provider,
                  userId,
                },
                token,
              );
            universitySignIn = true;
            // const orgs = cognitoUserInfo.attributes['custom:orgs']?.split(',');
            domain = provider;
            isUniversityEmail = !!userstatus;
          }

          if (!isUniversityEmail) {
            signinMethod = 'local';
            localStorage.setItem('sp', 'local');
            localStorage.removeItem('sign-in-method');
            universitySignIn = false;
            localStorage.removeItem(`selectedPlan-${userId}`);
          }

          let { universityLinked } = data;
          if (isUniversityEmail && !universityLinked && universitySignIn) {
            universityLinked = true;
            // make api call to update the attribute;
            const updateObj = { userId, code: domain };

            userInfoController.updateUniversityUserCount(updateObj, token);
          }

          if (isUniversityEmail && universityLinked && universitySignIn) {
            // make api call to get university status
            universityDetails = await getUniversityPlan(
              data.email,
              domain,
              userId,
            );
            localStorage.removeItem(`selectedPlan-${userId}`);
            if (universityDetails) {
              localStorage.setItem(`selectedPlan-${userId}`, 'universityPlan');
              dispatch({
                type: organizationActionType.UPDATE_ORGANIZATION_DETAILS,
                payload: {
                  ...universityDetails.organizationDetails,
                  isLoading: true,
                  code: universityDetails.code,
                  organizationIdentity: universityDetails?.organizationIdentity,
                  isSSO:
                    signinMethod === `NONSSO-${provider}`
                      ? false
                      : signinMethod === `SSO-${provider}`,
                },
              });
            }
          }
          const selectedPlan = localStorage.getItem(`selectedPlan-${userId}`);
          dispatch({
            type: actionTypes.GET_USER_INFO,
            payload: {
              userName: data.userName || null,
              isFirstSignIn: data.isFirstSignIn || false,
              isFirstSubscription: data.isFirstSubscription || false,
              wiseKoin: data.wiseKoin || 0,
              usedCoupon: data.usedCoupon || null,
              referredUser: data.referredUser || [],
              organisation: data.organisation || null,
              researchGroup: data.researchGroup || null,
              researchInterests: data.researchInterests || [],
              isEmailVerified: data.isEmailVerified || 1,
              totalEarned: data.totalEarned || 0,
              profileImageBlobURL: profileImageBlobURL || null,
              customerId: data.customerId || null,
              activePlan: data.activePlan || null,
              activeSubscription: data.activeSubscription || null,
              subscriptionStatus: data.subscriptionStatus || false,
              userInfoFetched: true,
              preferences: data.preferences || null,
              tutorials: data.tutorials || initialTutorialState,
              downloads: data.downloads || null,
              universityLinked,
              universityPlan: universityDetails,
              selectedPlan: selectedPlan || 'usersPlan',
              inputIntro: data.inputIntro || { fullName: null },
              isFullscreen: false,
              scaleLevel: 1,
              signUpQuestions: data.signUpQuestions || null,
            },
          });
        }
      } catch (err) {
        Logger.LogError(err);
      }
    },
  clearUserInfo: () => (dispatch) => clearUserInfo(dispatch),

  updateUserInfo: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_USER_INFO,
      payload: params,
    };
    dispatch(actionData);
  },
  updateProfileImageBlobURL:
    (...params) =>
    (dispatch) =>
      dispatch(updateProfileImageBlobURL(...params)),
  updateUserNotificationPreferences: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_USER_NOTIFICATION_PREFERENCES,
      payload: params,
    };
    dispatch(actionData);
  },

  setInputIntro: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_INPUT_INTRO,
      payload: params,
    };

    dispatch(actionData);
  },
};
